import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgCoupon = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M10 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM10 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 5a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 1 0 0-4V7a2 2 0 0 1 2-2h16ZM4 7h16v1.535A3.998 3.998 0 0 0 18 12c0 1.48.804 2.773 2 3.465V17H4v-1.535A3.998 3.998 0 0 0 6 12c0-1.48-.804-2.773-2-3.465V7Z", fill: color })));
};
export default factorySvgIcon(SvgCoupon);
//# sourceMappingURL=SvgCoupon.js.map